export interface ResponseExperienceTopCountryInterface {
  status: boolean;
  message: string;
  data: ExperienceTopCountryInterface[];
}

export interface ExperienceTopCountryInterface {
  countryId: number;
  countryName: string;
  countrySlug: string;
  photo_path: string;
  count: number;
}

export class ResponseExperienceTopCountryClasses {
  status: boolean = false;

  message: string = "";

  data: ExperienceTopCountryInterface[] | null = null;

  constructor(data: any) {
    this.status = data.status || false;
    this.message = data.message || "";
    this.data = data.data
      ? data.data.map((item: ExperienceTopCountryInterface) => {
          return {
            countryId: item.countryId,
            countryName: item.countryName,
            countrySlug: item.countrySlug,
            photo_path: item.photo_path,
            count: item.count,
          };
        })
      : [];
  }
}
